module.exports = __webpack_public_path__ + "img/home_selected.4d28a1ea.svg";